import React, { FunctionComponent } from 'react';

export const Presentation: FunctionComponent = () => {
  return (
    <div className="rtf-top-links">
      {/* start user-term */}
      <div className="user-terms">
        <div className="terms-body">
          <h2 className="title">利用規約（ユーザー向け）</h2>

          <p>株式会社READY TO FASHION（以下「当社」といいます。）は、当社がSNSサービス「READY TO FASHION」を含むすべてのサービス（以下「本サービス」と総称します。）を提供するにあたり、以下のとおり利用規約（以下「本利用規約」といいます。）を定めています。本利用規約は、ユーザーとして「RTFユーザーアカウント」（以下「本アカウント」といいます。）を登録し本サービスを利用されるすべての方（以下「ユーザー」といいます。）に適用されるため、本アカウントをご登録される前によくご覧ください。</p>

          <p className="terms-statement">第1条（本サービスのご利用と本利用規約などへの同意）</p>

          <p>ユーザーは、本利用規約および当社が本サービスの提供にあたり定める各種規約（以下「本利用規約など」と総称します。）に同意することにより、本利用規約などの定めに従って本アカウントを登録し、本サービスを利用することができます。本利用規約などにご同意いただけない場合、本アカウントをご登録いただき本サービスをご利用いただくことができません。ユーザーは、実際に本アカウントを登録することにより、本利用規約などの内容にご同意いただいたものとみなされます。</p>

          <p className="terms-statement">第2条（ユーザー会員登録）</p>
          <ul>
              <li>1. 本アカウントの登録については、当社所定の方法によりユーザーに関する情報を登録、送信することをもって、当該登録の申込みをしたものとみなします。</li>

              <li>2. 当社は、前項の申込みについて所定の審査を行うことができるものとします。</li>

              <li>3. 当社は、ユーザーとして不適当と判断した場合には、本アカウントの登録を拒否することができるものとします。</li>

              <li>4. 当社は、前項に基づき登録を拒否する場合、登録を拒否する理由を申込者に説明する義務を負わないものとします。</li>
          </ul>
          <p className="terms-statement">第3条（利用にあたっての環境整備）</p>
          <ul>
             <li> 1. ユーザーは、自らの費用と責任において、本サービスの利用にあたって必要な機器・ソフトウェア・通信手段などを用意し、これらを適切に接続、操作するものとします。</li>

             <li> 2. ユーザーは、自らの費用と責任において、自己の利用環境に応じ、コンピュータウィルスの感染、不正アクセスおよび情報漏洩の防止などのセキュリティ対策を講じるものとします。</li>
          </ul>
          <p className="terms-statement">第4条（ユーザーに関する情報の取扱い）</p>
          <ul>
              <li>1. 当社は、ユーザーが本アカウントの登録ならびに本サービスの申込みおよび利用にあたって、当社に対して提供した情報（以下「ユーザー情報」といいます。）を、当社の「<a href="/privacy">プライバシーポリシー</a>」に基づき、適切に取り扱うものとします。</li>

              <li>2. ユーザーは、当社がユーザー情報を、本サービスの提供に必要な範囲で、ユーザーの公開設定に従い、他のユーザーおよび掲載企業（法人、個人事業主を含みます。以下同じ。）の閲覧に供することをあらかじめ同意します。ユーザーは、ユーザー情報として提供されたコンテンツの公開について単独で責任を負います。ユーザーが公開を欲しない個人情報については、本サービス上で非公開とする、公開の範囲を限定する、安易に書き込まないなどの方法により対処するなど、十分にご注意ください。</li>
          </ul>
          <p className="terms-statement">第5条（利用履歴など）</p>
          <ul>
              <li>1. 当社は、ユーザーの本サービスの利用履歴（ページビュー、ユーザー向け企画への応募履歴・ユーザー向け企画への招待の確認・参加の状況、メッセージの送受信状況を含みますが、これに限られません。以下同じ。）、または利用履歴、ユーザーに関する情報を、個人を識別、特定できないように加工、集計、および分析した統計データ、属性情報などを作成し、当該利用履歴または統計データ、属性情報などを何らの制限なく閲覧、利用（掲載企業へ閲覧させること、本サービスの新機能の開発、市場の調査を含みますが、これに限られません。）することができる（通信の秘密に抵触する場合を除きます。）ものとし、ユーザーはこれをあらかじめ承諾します。</li>

              <li>2. 当社は、掲載企業およびユーザーに対してのアンケートその他の方法により、本サービスの利用に関連した就職、転職の事実などを確認することができるものとします。</li>
          </ul>
          <p className="terms-statement">第6条（本サービスの内容に関する非保証）</p>
          <ul>
              <li>1. 当社は、本サービスの品質にできる限りの注意を払っていますが、本サービスにより提供される情報（ユーザーが表明する情報、掲載企業またはユーザーが表明する掲載企業に関する情報および当社が提供する情報を含みます。）の完全性、正確性、有用性、最新性、真実性、エラー・バグなど不具合がないこと、セキュリティ上の欠陥が存在しないこと、ユーザーが期待する性質および商品的価値を有することなどについて保証するものではありません。また、本サービスにより提供される情報に基づいてユーザーが下した判断および行動した結果について、当社は責任を負いません。</li>

              <li>2. 当社は、ユーザーが掲載企業の実施するユーザー向け企画に参加可能となること、ユーザーが掲載企業に採用されることなど、本サービスの効果一切について、その確実性を保証するものではありません。</li>

              <li>3. 当社は、本サービスの確実な提供またはアクセス結果などにつき保証するものではありません。</li>

              <li>4. 当社は、ユーザーに対し、他のユーザーの資質・能力・経歴など、ユーザーに関する何らの保証も行わないものとします。</li>
          </ul>
          <p className="terms-statement">第7条（本サービスの内容に関する変更）</p>

          <p>当社は、当社の判断において、ユーザーへの事前の通知なくして、本サービスの内容もしくは仕様を変更し、または、本サービスの提供を停止することができるものとします。当社は、本サービスの変更などによりユーザーまたは第三者が被った損害について、一切責任を負わないものとします。</p>

          <p className="terms-statement">第8条（本サービスの利用制限）</p>
          <ul>
              <li>1. 当社は、本サービスのご利用を、一定の年齢以上の方に限定すること、当社が定めるユーザー情報の入力などの手続を経て一定の要件を満たしたユーザーのみに限定することなど、利用に際して条件を付することができるものとします。</li>

              <li>2. 当社は、ユーザーから本サービスの利用希望があった場合に、本サービスの利用を制限することがあります。</li>

              <li>3. 当社は、前項に基づき本サービスの利用を制限する場合、本サービスの利用を制限する理由を本サービスの利用を希望するユーザーに説明する義務を負わないものとします。</li>

              <li>4. 当社は、反社会的勢力など（暴力団・暴力団員・総会屋・社会運動など標ぼうゴロ・特殊知能暴力集団その他これらに準ずる者を意味します。以下同じ。）または反社会的勢力などと何らかの関係を持っていると当社が判断した方、本サービスを悪用する方、第三者に迷惑をかける害意のある方に対しては、ご利用をお断りしています。</li>
          </ul>
          <p className="terms-statement">第9条（ユーザー情報の登録・修正）</p>
          <ul>
              <li>1. ユーザーになろうとする者またはユーザーに、本アカウントの登録または本サービスの申込みもしくは利用にあたって自身の情報を登録していただく場合、（ア）真実かつ正確な情報を登録すること、（イ）登録情報が最新のものとなるよう適宜更新、修正すること、（ウ）登録情報の公開・非公開の設定その他の管理を行うことが、ユーザーの義務となります。</li>

              <li>2. ユーザーになろうとする者またはユーザーが、前項の義務を怠ったことにより不利益を被ったとしても、当社は一切責任を負わないものとします。</li>
          </ul>
          <p className="terms-statement">第10条（アカウント情報の自己管理）</p>
          <ul>
              <li>1. ユーザーの本アカウント情報は、ユーザー自身のみに適用される本アカウント情報として、ユーザーの責任において管理および保管するものとし、第三者に利用させてはならず、かつ、第三者に対して貸与、譲渡、名義変更、売買などをしてはならないものとします。</li>

              <li>2. 当社は、ユーザーの本アカウント情報の一致を確認した場合、当該本アカウント情報を保有する者として登録されたユーザーが本サービスを利用したものとみなします。</li>

              <li>3. 本アカウント情報が盗用された場合、または第三者に使用されていることが判明した場合には、ユーザーは、直ちにその旨を当社に通知し、当社の指定する措置を取るものとします。</li>

              <li>4. ユーザーによる本アカウント情報の管理不十分または第三者の利用などによる損害の責任は、ユーザーが負担するものとし、当社は責任を負わないものとします。</li>
          </ul>
          <p className="terms-statement">第11条（ご利用にあたっての禁止行為）</p>

          <p>本アカウントの登録ならびに本サービスの申込みおよび利用に際しては、以下に定める行為（それらを誘発する行為や準備行為も含みます。）を禁止します。</p>
          <ul className="narrow">
              <li>(1) 本利用規約などに違反する行為</li>
              <li>(2) 法令または公序良俗に違反する行為</li>
              <li>(3) 法令・社会規範・公序良俗に反するもの、他人に不当な不快感を与えるもの、または他人の権利を侵害し、もしくは侵害するおそれのあるものを、投稿、掲載、開示、提供または送信（以下これら投稿、掲載、開示、提供または送信する行為を総称して「投稿など」といいます。）する行為</li>
              <li>(4) 事実と異なる不正確な情報を登録または掲載する行為</li>
              <li>(5) 応募したユーザー向け企画への参加を正当な理由なく断る行為、ユーザーに関する真実または正確でない情報を提供する行為その他当社、ユーザー、掲載企業または第三者に迷惑を及ぼす行為</li>
              <li>(6) 本サービスに係るユーザー向け企画への応募を本サービス外で行う行為</li>
              <li>(7) 掲載企業から応募したユーザー向け企画に対する招待を受信した場合に、掲載企業の同意なしに当該招待に係る画面を第三者に開示する行為</li>
              <li>(8) 政治活動行為または宗教活動行為（ただし、当社が同意したものを除きます。）</li>
              <li>(9) 営利目的での本サービスの利用行為（ただし、当社が同意したものを除きます。）</li>
              <li>(10) 異性交際目的での本アカウントの登録行為または本サービスの利用行為</li>
              <li>(11) 当社や他者になりすます行為</li>
              <li>(12) スパム行為</li>
              <li>(13) 当社のサーバーまたはネットワークの機能を破壊、妨害する行為</li>
              <li>(14) コンピュータウィルスなどの有害なコンピュータプログラムなどを送信または掲載する行為</li>
              <li>(15) 本サービス・当社の配信する広告、または本サービス上で提供されているサービス・広告を妨害する行為</li>
              <li>(16) 他のユーザーの個人情報や履歴情報および特性情報（当社のプライバシーポリシーにて定義します。）などを無断で収集、蓄積する行為</li>
              <li>(17) 本サービスまたは本サービスを通じて入手した情報を、提供の趣旨に背いた目的で利用する行為</li>
              <li>(18) 他のユーザーのアカウント情報を使用して本サービスを利用する行為</li>
              <li>(19) 手段の種類を問わず、他人からアカウント情報を入手し、または他人にアカウント情報を開示、提供する行為</li>
              <li>(20) 本サービスに関連して、反社会的勢力などに直接、間接に利益を提供する行為</li>
              <li>(21) その他、上記各号に準じて当社が不適切と判断する行為</li>
          </ul>
          <p className="terms-statement">第12条（違反行為などへの対応）</p>

          <p>当社は、本サービスを適正に運営するため、以下の場合には、あらかじめ何らの通知をすることなく、ユーザーに対して、コンテンツその他の情報の全部もしくは一部の削除、本サービスの利用の一時停止もしくは制限、またはユーザーの本アカウントの削除、登録取消しを含む本利用契約の解除などの措置、あるいは、違反行為の中止、送信または投稿した情報の自発的な削除・訂正を求める措置、違反事実を本サービス内外で開示する措置（違法行為の可能性がある場合における警察その他の公的機関への通報を含みます。）を講じる ことができるものとします。<br />
             また、ユーザーが複数の本アカウントを登録している場合には、それらすべての本アカウントに対して上記措置がとられる場合があります。<br />
             なお、当社は、本条に基づき当社が行った措置によりユーザーに生じた不利益や損害について、一切の責任を負わないものとします。</p>
          <ul className="narrow">
              <li>(1) ユーザーが本利用規約などに定められている事項に違反した場合、またはそのおそれがあると当社が判断した場合</li>
              <li>(2) ユーザーが破産もしくは民事再生の手続の申立てを受け、またはユーザー自らがそれらの申立てを行うなど、ユーザーの信用不安が発生したと当社が判断した場合</li>
              <li>(3) 本アカウント情報が反社会的勢力などによって登録もしくは使用された場合、またはそれらのおそれがあると当社が判断した場合</li>
              <li>(4) ユーザーが1年間にわたって本アカウント情報または当社のサービスを使用していない場合</li>
              <li>(5) 当社からユーザーに対する問合せその他の回答を求める連絡に対して1か月間応答がない場合</li>
              <li>(6) その他、ユーザーとの信頼関係が失われた場合など、当社とユーザーとの契約関係の維持が困難であると当社が判断した場合</li>
          </ul>
          <p className="terms-statement">第13条（本サービスなどの再利用の禁止）</p>

          <p>ユーザーが、本サービスやそれらを構成するデータを、当該サービスの提供目的を超えて利用した場合、当社は、それらの行為を差し止める権利およびそれらの行為によってユーザーが得た利益相当額を当社に対して支払うよう請求する権利を有します。</p>

          <p className="terms-statement">第14条（当社に対する補償）</p>

          <p>ユーザーの行為が原因で生じたクレームなどに関する当社の対応に関連して、当社が費用を支出した場合または当社が第三者に対して賠償金などの支払いを行った場合、ユーザーは、当社が支出した費用や第三者に支払った賠償金など（当社がクレームなどへの対応のために負担した弁護士費用を含みます。）を負担するものとします。</p>

          <p className="terms-statement">第15条（ユーザーのデータおよびコンテンツの取扱い）</p>
          <ul>
              <li>1.{'\u3000'}ユーザーが本サービスの利用にあたって本サービスに投稿などをしたコンテンツ（以下「投稿コンテンツ」といいます。）が著作物に該当する場合、その著作権は、ユーザーまたは投稿コンテンツの著作者に帰属し、当社が投稿コンテンツに関して著作権を取得することはありません。ただし、当社は、個人情報保護法その他の法令を遵守しユーザーの個人情報に十分配慮した上で、本サービスの提供・維持・改善、本サービスの宣伝・プロモーション、またはメンテナンスその他の本サービスの円滑な運営のために、投稿コンテンツを複製、翻訳、翻案、上映、展示、頒布、譲渡、貸与、出版、自動公衆送信およびそのために必要な送信可能化を無償、無期限かつ地域非限定で行うことができるものとします。</li>

              <li>2.{'\u3000'}当社は、本利用規約などの順守状況などを確認する目的で、必要に応じて投稿コンテンツの内容を閲覧し、本利用規約などに照らして削除することができるものとします。</li>

              <li>3.{'\u3000'}当社は、本サービスの運用には万全を期しておりますが、運用上の事情により、または、不可抗力の事情により、やむを得ず投稿コンテンツが公開対象範囲外の方に公開されてしまう可能性もありますので、ユーザーは、あらかじめそのことにご同意いただいたうえで、本サービスをご利用いただくものとします。</li>

              <li>4.{'\u3000'}ユーザーが、本サービスにおいて、複数のユーザーあるいは掲載企業の手によって引用、編集、記述、修正、削除など（以下「引用など」といいます。）がなされてひとつの情報が形成されていく機能を提供するサービスへ投稿などをされた場合には、当社は、ユーザーが投稿などをしたコンテンツを他のユーザーあるいは掲載企業が自由に引用などの利用を行うことをユーザーが承認し、著作権、著作者人格権その他の権利を行使しないことを、ユーザーにお約束いただいたものとみなします。</li>

              <li>5.{'\u3000'}ユーザーは、当社および当社から権利を承継しまたは許諾された者に対し、著作者人格権を行使しないものとします。</li>

              <li>6.{'\u3000'}ユーザーは、自己の責任において投稿コンテンツのバックアップを行い、当社は、投稿コンテンツのバックアップを行う義務を負わないものとします。ユーザーが本サービスを利用して投稿または送信した投稿コンテンツが全部もしくは一部消滅し、または改ざんされた場合であっても、当社はそれを回復する責任を負いません。</li>

              <li>7.{'\u3000'}当社は、ユーザーの本アカウント削除後も、ユーザーが当社に提供した情報を任意で保有・利用・廃棄することができるものとします。</li>
          </ul>
          <p className="terms-statement">第16条（広告掲載）</p>

          <p>当社は、本サービス上に、当社または当社に掲載依頼をした第三者の広告を掲載することができるものとします。</p>

          <p className="terms-statement">第17条（当社の免責事項）</p>
          <ul>
              <li>1. 当社の債務不履行に基づく損害賠償責任は、当社の故意または重過失によらない場合には免責されるものとします。ただし、ユーザーとの本利用規約などに基づく当社のサービスのご利用に関する契約が消費者契約法に定める消費者契約に該当する場合、上記の免責は適用されないものとし、当社は、当社の故意・重過失に起因する場合を除き、通常生じうる損害の範囲内で、かつ、有料サービスにおいては代金額（継続的なサービスの場合は1か月分相当額）を上限として損害賠償責任を負うものとします。</li>

              <li>2. 当社は、天災地変その他の不可抗力、ユーザーまたは第三者の責めに帰すべき事由によりユーザーに生じた損失（①ウイルスまたはハッキングによるサーバダウン、システム障害、データの流出、損壊および誤った情報の掲載、②ユーザーの操作ミスなどによるデータの流出、損壊、就職、転職機会、採用機会の喪失、ならびに③当社のシステム環境の変化、当社のシステムの瑕疵を含みます。）につき、何らの責任も負わないものとします。</li>

              <li>3. 当社は、本サービスの提供に関連してユーザー間で生じたトラブル、ユーザー向け企画の実施に関して掲載企業とユーザーとの間に生じたトラブル、その他ユーザー間または掲載企業とユーザーの間に生じた一切のトラブル（インターネット上のトラブルおよび対面時のトラブルを含みますが、これらに限られません。）について、何らの責任も負わないものとします。万一、ユーザー間または掲載企業とユーザーとの間に紛争などが発生し、当社が直接これにやむを得ず対応した場合、ユーザーは、当社に発生した損害、費用（合理的な弁護士費用を含みます。）などの一切を補償するものとします。</li>

              <li>4. 当社は、ユーザーが、①本サービスを利用したこと、または利用できなかったこと、②不正アクセスや不正な改変がなされたこと、③掲載企業による行為、④他のユーザーによる行為、⑤第三者のなりすまし行為、⑥その他これらに準じて本サービスに関連する事項に起因しまたは関連して生じた一切の損害につき、損害賠償責任を負わないものとします。</li>
          </ul>
          <p className="terms-statement">第18条（外部サービス利用上の注意）</p>

          <p>ユーザーが、本サービスの利用にあたり、Facebook、Twitter、LINEその他の外部サービスなどを利用する場合には、当該外部サービスについては、当該外部サービスを提供する企業または個人などが責任を負うものとし、当社は、当該外部サービスにつき、いかなる保証も行うものではありません。</p>

          <p className="terms-statement">第19条（本利用規約などの変更について）</p>
          <ul>
              <li>1.{'\u3000'}当社は、当社が必要と判断した場合には、ユーザーに対する事前の通知なくして、本利用規約などの内容を変更することができるものとします。ただし、当該変更がユーザーに大きな影響を与える場合には、あらかじめ合理的な事前告知期間を設けるものとします。</li>

              <li>2.{'\u3000'}変更後の本利用規約などは、当社が別途定める場合を除いて、本サービスの提供にあたり表示された時点から効力を生じるものとします。</li>

              <li>3.{'\u3000'}ユーザーが、本利用規約などの変更の効力が生じた後に本サービスを利用する場合には、変更後の本利用規約などのすべての記載事項に同意したものとみなされます。</li>
          </ul>
          <p className="terms-statement">第20条（保守作業などによる一時的中断）</p>
          <ul>
              <li>1.{'\u3000'}当社は、次の各号いずれかの事由に該当する場合、ユーザーに事前に通知することなく、一時的に本サービスの提供を中断することがあります。<br /><br />
                  <ul>
                      <li>(1){'\u3000'}本サービスの仕様変更または本サービス提供のためのシステムまたは関連設備の保守または修繕を定期的または緊急に行うとき</li>
                      <li>(2){'\u3000'}当社が利用する通信回線、電力などの提供が中断されたとき</li>
                      <li>(3){'\u3000'}火災、停電などにより本サービスの提供ができなくなったとき</li>
                      <li>(4){'\u3000'}地震、台風、洪水、津波などの天災その他の非常事態が発生し、またそのおそれが生じたために、法令・指導により通信の制限などの要請、指示があった場合または当社が必要と判断したとき</li>
                      <li>(5){'\u3000'}法令の改正・成立などにより本サービスの運営が困難または不可能になった場合</li>
                      <li>(6){'\u3000'}技術的に不可能な事由により本サービスの提供ができなくなったとき</li>
                      <li>(7){'\u3000'}その他やむを得ない事由により本サービスの一時的な中断が必要と当社が判断したとき</li>
                  </ul>
              </li>

              <li>2.{'\u3000'}当社は、本サービスの提供の遅滞または一時的な中断が発生したとしても、これに起因してユーザーまたは第三者が被った損害・不利益については、一切責任を負わないものとします。</li>
          </ul>
          <p className="terms-statement">第21条（本サービスの中止）</p>

          <p>当社は、当社が定める相当程度の予告期間をもってユーザーに本サービス上にて通知の上、本サービスの提供を中止することができます。</p>

          <p className="terms-statement">第22条（退会）</p>

          <p>ユーザーは、本サービスの利用の終了を希望する場合は、当社が定める所定の方法により当社に届け出るものとします。当社は、退会したユーザーの登録情報、コンテンツについて継続して保有する義務を負わないものとします。</p>

          <p className="terms-statement">第23条（通知または連絡）</p>

          <p>ユーザーが当社への連絡を希望する場合には、当社が指定するメールアドレス(info.service@readytofashion.jp)宛てのメールにより行っていただくものとします。当社は、ユーザーからのお問い合わせに対する回答を原則としてメールのみで行います。なお、当社はユーザーからのお問い合わせに対して回答する義務を負うものではありません。</p>

          <p className="terms-statement">第24条（権利義務などの譲渡の禁止）</p>

          <p>ユーザーは、本利用規約などに基づくすべての契約について、その契約上の地位およびこれにより生じる権利義務の全部または一部を、当社の書面による事前の承諾なく、第三者に譲渡もしくは貸与し、または担保に供することはできません。</p>

          <p className="terms-statement">第25条（事業譲渡などの場合）</p>

          <p>当社が、本サービスまたは本サービスに関する事業を、事業譲渡し、または合併もしくは会社分割などにより第三者に承継させた場合、当社は、当該事業の承継に伴い、本利用契約上の地位、権利および義務ならびにユーザーの登録情報その他の情報を、当該事業の譲受人に譲渡または承継させることができるものとします。ユーザーは、当該譲渡または承継についてあらかじめこれに同意したものとみなします。</p>

          <p className="terms-statement">第26条（秘密保持）</p>

          <p>ユーザーは、本サービスに関連して当社がユーザーに対して秘密に取り扱うことを求めて開示した非公知の情報について、当社の書面による事前の承諾がある場合を除き、秘密に取り扱うものとし、第三者に開示することはできないものとします。</p>

          <p className="terms-statement">第27条（本利用規約などの適用制限）</p>

          <p>本利用規約などの規定が、ユーザーとの本利用規約などに基づく契約に適用される関連法令に反するとされる場合、当該規定は、その限りにおいて、当該ユーザーとの間で成立した利用契約には適用されないものとします。ただし、この場合であっても、本利用規約などの他の規定の効力には影響しないものとします。</p>

          <p className="terms-statement">第28条（準拠法、裁判管轄）</p>

          <p>本利用規約などの成立、効力発生、解釈にあたっては、日本法を準拠法とします。また、本サービス（掲載内容や広告などを含みます。）に起因または関連して当社とユーザーとの間で生じた紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>

          <p className="terms-statement">第29条（話合いの手続）</p>

          <p>本サービス上の投稿コンテンツについて苦情などが寄せられ、苦情の申告をした方と当該申告の対象となったコンテンツの投稿をしたユーザーとの間で話合いによる解決が適切であると当社が判断した場合には、当社は、当社が定める手順に従って話合いの手続を求めることができるものとします。</p>

          <p>(附則)</p>

          <p>平成29年1月20日制定・適用<br />
             平成31年1月15日改訂・適用</p>

        </div>
      </div>
      {/* end user-term */}
    </div>
  );
};
